export enum SiteNames {
	Heni = 'HENI',
	HeniArtists = 'HENI Artists',
	HeniDigital = 'HENI Digital',
	HeniEditions = 'HENI Editions',
	HeniExhibitions = 'HENI Exhibitions',
	HeniFab = 'HENI Fab',
	HeniFaq = 'HENI FAQ',
	HeniHat = 'HENI HAT',
	HeniMerch = 'HENI Merch',
	HeniNews = 'HENI News',
	HeniNft = 'HENI NFT',
	HeniPrimary = 'HENI Primary',
	HeniPublishing = 'HENI Publishing',
	HeniPrivateSales = 'HENI Private Sales',
	HeniShop = 'HENI Shop',
	HeniTalks = 'HENI Talks',
}
